import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@fortem-monorepo/react-ui'

export const StrategyReviewTable = ({ headers, rows }: { headers: string[]; rows: string[][] }) => (
  <Table>
    <TableHeader>
      <TableRow>
        {headers.map((header) => (
          <TableHead key={header}>{header}</TableHead>
        ))}
      </TableRow>
    </TableHeader>
    <TableBody>
      {rows.map(([label, ...values]) => (
        <TableRow key={label}>
          <TableCell>{label}</TableCell>
          {values.map((value, index) => (
            <TableCell key={index} className="whitespace-normal break-words">
              {value}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </Table>
)
